import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";
import {Table} from "semantic-ui-react";

export default class ContractsTradingPositionTableHeader extends Component {

  static Layout = [
    { column: "date", name: "month" },
    { column: "baseTotalCapacity", name: "Total" },
    { column: "baseTradedCapacity", name: "Traded" },
    { column: "baseExposedCapacity", name: "Exposed" },
    { column: "baseTradeWA", name: "Traded WA" },
    { column: "peakTotalCapacity", name: "Total" },
    { column: "peakTradedCapacity", name: "Traded" },
    { column: "peakExposedCapacity", name: "Exposed" },
    { column: "peakTradeWA",name: "Traded WA" }
  ];

  render() {
    const structuredHeading = (<Table.Row>
      <Table.HeaderCell colSpan="1"></Table.HeaderCell>
      <Table.HeaderCell colSpan='4'>Baseload</Table.HeaderCell>
      <Table.HeaderCell colSpan='4'>Peak</Table.HeaderCell>
    </Table.Row>);

    return (
        <React.Fragment>
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ContractsTradingPositionTableHeader.Layout} structuredHeading={structuredHeading} />
        </React.Fragment>
    )
  }



}

